import lodash from 'lodash';

export const numberView = (
    value: Undefinable<number | string>,
    precision: number = 2
) => round(value, precision).toFixed(precision);

export const round = (
    value: Undefinable<number | string>,
    precision: number = 2
) => lodash.round(Number(value || ''), precision);

export const sum = (arr: Undefinable<string | number>[]): number => {
    return lodash.sum(arr);
};

export const sumBy = <T>(
    arr: Undefinable<T>[],
    indentity: string
): number => lodash.sumBy(arr, indentity);

export const substract = (
    minuend: Undefinable<number | string>,
    subtrahend: Undefinable<number | string>
): number => lodash.subtract(Number(minuend || ''), Number(subtrahend || ''));
